import { Input as Component } from './styled';

export const Input = Component;
